/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import {CollectionListMessage} from "../../../messages"
import { VApplication } from "../../../../../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {GET_ROOT_NODES} from "../../../graphql";

const MODULE_NAME =
  "services.PortfolioListPageService.machines.GetCollectionList.state.getCollectionListFromServer";
const log = LoggerModule?.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export const getCollectionListFromServer = async (context: any, event: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const msg = context?.input as CollectionListMessage;
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");
       console.log("getCollectionListFromServer", msg?.offset, msg?.size);
      const res = await client?.query({
        query: GET_ROOT_NODES,
        variables: {
          "tree": "STUDENT_PORTFOLIO",
          input: {
            filter: {
            },
            offset: msg?.offset,
            size: msg?.size,
          },
        },
        fetchPolicy: "network-only",
      });
      if (res?.data?.getListOfNode) {
        msg.nodes = res?.data?.getListOfNode;
        return resolve(true);
      }
      const error = "Query result does not have proper formatted values";
      log?.error(MODULE_NAME, "error in getCollectionListFromServer", error);
      return reject(error);
    } catch (err: any) {
      log?.error(MODULE_NAME, "error in getCollectionListFromServer", err);
      return reject(err?.message);
    }
  });
};
